import { FoodSectionEnum } from "@pages/Food/Food.constants";
import type useFoodProfilePage from "@pages/Food/hooks/useFoodProfilePage";

type SectionsWithData = ReturnType<typeof useFoodProfilePage>["sectionsWithData"];

/**
 * Sections nav of the refreshed page: Menu always, then the sections that have data, in page order.
 * Charts is never listed: the refreshed page has no Charts section (its content is in the sidebar).
 */
export function buildFoodRefreshNavItems({ reports, consumer, social, launches }: SectionsWithData) {
    const items: Array<{ id: FoodSectionEnum; title: string }> = [{ id: FoodSectionEnum.Menu, title: "Menu" }];

    if (reports) items.push({ id: FoodSectionEnum.Reports, title: "Reports" });
    if (consumer) items.push({ id: FoodSectionEnum.Consumer, title: "Consumer" });
    if (social) items.push({ id: FoodSectionEnum.Social, title: "Social" });
    if (launches) items.push({ id: FoodSectionEnum.Launches, title: "Launches" });

    return items;
}
